import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

const collapseElem = () => {
  const $collapse = $('.c-collapse');
  if ($collapse && $collapse.length) {
    $collapse.collapse();
  }
};
export default collapseElem;



// WEBPACK FOOTER //
// ./src/scripts/modules/collapse.js